import React from 'react'
import { Route } from 'react-router-dom'
import * as ROUTE from 'constants/appRouting'
import Page403 from './routes/403'
import Page404 from './routes/404'
import Page500 from './routes/500'
import './exceptions.scss'

function Page() {
  return (
    <div className="page-err-container">
      <Route path={ROUTE.ERROR_403} component={Page403} />
      <Route path={ROUTE.ERROR_404} component={Page404} />
      <Route path={ROUTE.ERROR_500} component={Page500} />
    </div>
  )
}

export default Page
